<script lang="ts">
  import { auth } from "$lib/stores/auth.svelte";
  import { navigate } from "$lib/router.svelte";
  import Link from "$lib/components/Link.svelte";

  let email = $state("");
  let password = $state("");
  let error = $state<string | null>(null);
  let loading = $state(false);

  async function submit(e: Event) {
    e.preventDefault();
    error = null;
    loading = true;
    try {
      await auth.login(email, password);
      navigate("/");
    } catch (err: any) {
      error = err.message || "Falha ao entrar";
    } finally {
      loading = false;
    }
  }
</script>

<div class="min-h-screen flex items-center justify-center px-4">
  <form onsubmit={submit} class="card w-full max-w-md space-y-4">
    <h1 class="text-2xl font-bold text-brand">TáKite</h1>
    <p class="text-slate-600 text-sm">Entrar na sua conta</p>

    {#if error}
      <div class="bg-red-50 border border-red-200 text-red-700 text-sm rounded p-2">{error}</div>
    {/if}

    <div>
      <label class="label" for="email">E-mail</label>
      <input id="email" type="email" class="input" bind:value={email} required />
    </div>
    <div>
      <label class="label" for="pwd">Senha</label>
      <input id="pwd" type="password" class="input" bind:value={password} required />
    </div>

    <button type="submit" class="btn-primary w-full" disabled={loading}>
      {loading ? "Entrando…" : "Entrar"}
    </button>

    <p class="text-sm text-slate-600 text-center">
      Não tem conta? <Link to="/register" class="text-brand font-medium">Cadastrar</Link>
    </p>
  </form>
</div>
